export default __webpack_public_path__ + "static/media/thumbnail.1e20ad57.png";